import { Fragment } from 'react';

import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
    const layoutGuest = (
        <Fragment>
            <Navbar></Navbar>
                { children }
            <Footer></Footer>
        </Fragment>
    );

    return layoutGuest;
}

export default Layout;